/**
 * Centralized helper for appending country to meta titles
 */

const countryDisplayNames = {
    'KENYA': 'Kenya',
    'GHANA': 'Ghana',
    'UGANDA': 'Uganda',
    'DRC': 'DRC'
};

/**
 * Appends country name to title if not already present
 * @param {string} title - Original title
 * @param {string} country - Country code
 * @returns {string} Title with country appended
 */
export function appendCountryToTitle(title, country) {
    if (!title || !country) return title;

    const countryName = countryDisplayNames[country] || country;

    // Skip if country already in title
    if (title.includes(countryName)) return title;

    // Check if title already ends with "Betika" and append country
    if (title.includes('| Betika')) {
        return title.replace('| Betika', `| Betika - ${countryName}`);
    }

    if (title.includes('Betika')) {
        // If Betika is in the title but not with pipe separator
        return `${title} - ${countryName}`;
    }

    // If neither pattern matches, append both Betika and country
    return `${title} | Betika - ${countryName}`;
}

export { countryDisplayNames };